import Page from "../page";
import Mda from "../../components/mda/mda";

const MdaPage = () => {
  return (
    <Page>
      <Mda />
    </Page>
  );
};

export default MdaPage;
